export default __webpack_public_path__ + "static/media/fingerprint.668e0fae.png";